import {
  AORIGEM_OS_MANUT_AUTOMATICA,
  AORIGEM_OS_MANUT_IMPORTADO,
  AORIGEM_OS_MANUT_MANUAL,
  ASIM
} from 'consts';

/* Salva configurações no localStorage */
export const saveConfigurations = (configurations, nameConfiguration) => {
  sessionStorage.setItem(nameConfiguration, JSON.stringify(configurations));
};

/* Carrega configurações armazenadas no localStorage */
export const loadConfigurations = (nameConfiguration) => {
  const storedConfigs = sessionStorage.getItem(nameConfiguration);

  if (storedConfigs) {
    return JSON.parse(storedConfigs);
  }

  return null;
};

/* Pega informação configuração específica */
export const getConfigField = (field, nameConfiguration) => {
  let nameCfg = nameConfiguration;

  if (((nameCfg) === "") || (nameCfg === undefined)) {
    nameCfg = 'cfg';
  }

  const configs = loadConfigurations(nameCfg);

  if (configs && typeof configs === 'object') {
    return configs[field];
  }

  return null;
};

/* Salva Empresa no sessionStorage */
export const saveCompany = (company) => {
  sessionStorage.setItem('empresa', JSON.stringify(company));
};

/* Carrega empresa armazenada no localStorage */
export const loadCompany = () => {
  const storedCompany = sessionStorage.getItem('empresa');

  if (storedCompany) {
    return JSON.parse(storedCompany);
  }

  return null;
};

/* Pega informação específica empresa*/
export const getCompanyField = (field) => {
  const company = loadCompany();

  if (company && typeof company === 'object') {
    return company[field];
  }

  return null;
};

/* Carrega PDV armazenada no localStorage */
export const loadPDV = () => {
  const storedPDV = sessionStorage.getItem('pdv');

  if (storedPDV) {
    return JSON.parse(storedPDV);
  }

  return null;
};

/* Salva PDV no sessionStorage */
export const savePDV = (pdv) => {
  sessionStorage.setItem('pdv', JSON.stringify(pdv));
};

/* Pega campo específico PDV */
export const getPDVField = (field) => {
  const pdv = loadPDV();

  if (pdv && typeof pdv === 'object') {
    return pdv[field];
  }

  return null;
};

/* Retorna o estado da situação de OS de manutenção de veículo */
export const getSituacaoOsManut = (situacao) => {
  switch (situacao) {
    case 1: return 'aberta';
    case 2: return 'encerrada';
    case 3: return 'cancelada';
    default: return 'nova';
  }
};

/* Retorna a cor conforme o estado da situação de OS de manutenção de veículo */
export const getSituacaoOsManutColor = (situacao) => {
  switch (situacao) {
    case 1: return '#1660b5';
    case 2: return '#616161';
    case 3: return '#d32f2f';
    default: return '#3a913f';
  }
};

/* Retorna a descrição da origem da OS de manutenção de veículo */
export const getOrigemOsManut = (origem) => {
  const origemOS = Number(origem ?? AORIGEM_OS_MANUT_MANUAL);

  if (origemOS === AORIGEM_OS_MANUT_IMPORTADO) return 'importado';
  if (origemOS === AORIGEM_OS_MANUT_AUTOMATICA) return 'automática';

  return 'manual';
};

/* Invalida valores nulos, vazios ou indefinidos */
export const isInvalidSelect = (value) => {
  return value === 0 || value === '0' || value === '' || value === undefined;
};

/* Valida campos ComboPadrao */
export const validateComboFields = (data, comboFields) => {
  const comboErrors = {};

  comboFields.forEach(({ field, message }) => {
    if (isInvalidSelect(data[field])) {
      comboErrors[field] = message;
    }
  });

  return comboErrors;
};

/* Verifica se uma flag S/N retornada do banco está ativa */
export const isFlagAtiva = (item, field) => {
  const value = item[field] ?? item[field.toUpperCase()];

  return String(value || '').trim().toUpperCase() === ASIM;
};